import React, { useEffect } from "react";
import Main from "./Main/Router";
import { BrowserRouter, Routes } from "react-router-dom";

if (process.env.REACT_APP_SITE_ENV === "production")
	console.log = function no_console() {};

const App = () => {
	return (
		<div className='App' style={{ overflowX: "clip" }}>
			<BrowserRouter>
				<Main path='/' />
			</BrowserRouter>
		</div>
	);
};

export default App;
